export const appHead = {"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1, maximum-scale=1.0, user-scalable=no"},{"hid":"description","name":"description","content":""},{"name":"format-detection","content":"telephone=no"}],"link":[{"rel":"icon","type":"image/x-icon","href":"/favicon.ico"},{"rel":"icon","type":"image/png","sizes":"192x192","href":"/android-chrome-192x192.png"},{"rel":"icon","type":"image/png","sizes":"256x256","href":"/android-chrome-256x256.png"},{"rel":"apple-touch-icon","sizes":"57x57","href":"/apple-touch-icon-57x57.png"},{"rel":"apple-touch-icon","sizes":"60x60","href":"/apple-touch-icon-60x60.png"},{"rel":"apple-touch-icon","sizes":"72x72","href":"/apple-touch-icon-72x72.png"},{"rel":"apple-touch-icon","sizes":"76x76","href":"/apple-touch-icon-76x76.png"},{"rel":"apple-touch-icon","sizes":"114x114","href":"/apple-touch-icon-114x114.png"},{"rel":"apple-touch-icon","sizes":"120x120","href":"/apple-touch-icon-120x120.png"},{"rel":"apple-touch-icon","sizes":"144x144","href":"/apple-touch-icon-144x144.png"},{"rel":"apple-touch-icon","sizes":"152x152","href":"/apple-touch-icon-152x152.png"},{"rel":"apple-touch-icon","sizes":"180x180","href":"/apple-touch-icon-180x180.png"},{"rel":"mask-icon","href":"/safari-pinned-tab.svg"},{"rel":"icon","type":"image/png","sizes":"16x16","href":"/favicon-16x16.png"},{"rel":"icon","type":"image/png","sizes":"32x32","href":"/favicon-32x32.png"},{"rel":"icon","type":"image/png","sizes":"194x194","href":"/favicon-194x194.png"},{"rel":"preload","type":"font/woff2","as":"font","href":"/font/ACaslonPro-Regular.woff2","crossorigin":""},{"rel":"preload","type":"font/woff2","as":"font","href":"/font/ProximaNova-Bold.woff2","crossorigin":""},{"rel":"preload","type":"font/woff2","as":"font","href":"/font/ProximaNova-Regular.woff2","crossorigin":""}],"style":[],"script":[{"src":"https://consent.cookiefirst.com/sites/luma-delikatessen.ch-4433315f-396d-46ac-886a-fe31e91fc804/consent.js","async":true}],"noscript":[],"title":"luma-du-frontend","htmlAttrs":{"lang":"de"}}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = false

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink"}

export const asyncDataDefaults = {"deep":true}

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false